// src/components/Facilities.jsx
import { useState, useEffect } from "react";

const facilities = [
  {
    title: "Bedsheets Provided",
    icon: "🛏️",
    image:
      "https://5.imimg.com/data5/ANDROID/Default/2021/9/TL/QA/CG/3929269/product-jpeg.jpg",
  },
  {
    title: "Meals",
    icon: "🍽️",
    image:
      "https://i.pinimg.com/736x/f5/91/dc/f591dc1a53f8be154769f9c816a610cc.jpg",
  },
  {
    title: "Sports Ground",
    icon: "🏏",
    image:
      "https://t3.ftcdn.net/jpg/00/64/01/76/360_F_64017651_wYll2mTJh8zNVj7mK6Do0gZO09X0Ezq0.jpg",
  },
  {
    title: "Computer Access",
    icon: "💻",
    image:
      "https://media.istockphoto.com/id/506340238/photo/pc-room.jpg?s=612x612&w=0&k=20&c=hClJ3bjnW6n8gXSNbotpe520ofrREJYlJNMElU5CWJA=",
  },
  {
    title: "Television",
    icon: "📺",
    image:
      "https://www.shutterstock.com/image-photo/4k-monitor-isolated-on-white-260nw-357968483.jpg",
  },
  {
    title: "CCTV Surveillance",
    icon: "🎥",
    image:
      "https://t3.ftcdn.net/jpg/00/86/09/02/360_F_86090219_AgQYqc6e5WTemRT4gUBm9nWGfz3dmBan.jpg",
  },
];

export default function Facilities() {
  const [selectedImage, setSelectedImage] = useState(null);

  // Close modal on Esc
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setSelectedImage(null);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [selectedImage]);

  return (
    <section
      id="facilities"
      className="bg-gradient-to-b from-cream via-yellow-50/30 to-white py-12 sm:py-16 md:py-20 lg:py-24 px-4 sm:px-6 md:px-8 lg:px-10 relative overflow-hidden"
    >
      {/* Background decorative elements */}
      <div className="absolute top-10 right-10 w-32 sm:w-40 md:w-48 h-32 sm:h-40 md:h-48 bg-yellow-100/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-32 sm:w-40 md:w-48 h-32 sm:h-40 md:h-48 bg-maroon/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto text-center relative z-10">
        {/* Section Header */}
        <div className="mb-10 sm:mb-12 md:mb-14 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-maroon mb-3 sm:mb-4 tracking-wide px-2">
            Our Facilities
          </h2>
          <div className="mx-auto w-16 sm:w-20 md:w-24 lg:w-28 h-1 bg-gradient-to-r from-transparent via-maroon to-transparent rounded-full shadow-md"></div>
          <p className="mt-4 sm:mt-5 md:mt-6 text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            We provide world-class amenities to ensure a comfortable and enriching hostel experience
          </p>
        </div>

        {/* Facilities Grid */}
        <div className="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 md:gap-8 lg:gap-10">
          {facilities.map((facility, index) => (
            <div
              key={index}
              className="bg-white rounded-xl sm:rounded-2xl shadow-md hover:shadow-2xl p-5 sm:p-6 md:p-7 lg:p-8 flex flex-col items-center justify-between text-center cursor-pointer 
              transform transition-all duration-500 hover:-translate-y-1 sm:hover:-translate-y-2 hover:scale-105 border border-gray-100 group"
            >
              {/* Icon */}
              <div className="text-4xl sm:text-5xl md:text-6xl mb-3 sm:mb-4 transform group-hover:scale-110 transition-transform duration-300">
                {facility.icon}
              </div>

              {/* Title */}
              <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-800 mb-3 sm:mb-4 px-2 min-h-[2.5rem] sm:min-h-[3rem] flex items-center">
                {facility.title}
              </h3>

              {/* View Image Button */}
              <button
                onClick={() => setSelectedImage(facility.image)}
                className="mt-auto px-4 sm:px-5 py-2 sm:py-2.5 bg-maroon text-white text-xs sm:text-sm font-medium rounded-full shadow-md 
                hover:bg-maroonDark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-maroon transition-all duration-300 
                transform hover:scale-105 active:scale-95 w-full sm:w-auto"
                aria-label={`View image of ${facility.title}`}
              >
                View Image
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fade-in"
          onClick={() => setSelectedImage(null)}
          role="dialog"
          aria-modal="true"
        >
          <div
            className="relative bg-white rounded-lg sm:rounded-xl md:rounded-2xl overflow-hidden shadow-2xl max-w-xs sm:max-w-md md:max-w-2xl lg:max-w-3xl xl:max-w-4xl w-full p-3 sm:p-4 md:p-5 lg:p-6 
            transform transition-all duration-300 scale-95 animate-scale-up"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button - top right */}
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-2 right-2 sm:top-3 sm:right-3 md:top-4 md:right-4 bg-maroon text-white w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 rounded-full shadow-lg 
              hover:bg-red-600 transition-all duration-300 z-10 flex items-center justify-center font-bold text-lg sm:text-xl transform hover:scale-110 active:scale-95"
              aria-label="Close modal"
            >
              ✕
            </button>

            {/* Image */}
            <div className="relative">
              <img
                src={selectedImage}
                alt={
                  facilities.find((f) => f.image === selectedImage)?.title ||
                  "Facility"
                }
                className="w-full h-48 xs:h-56 sm:h-64 md:h-80 lg:h-96 object-contain rounded-lg bg-gray-50"
              />
            </div>

            {/* Title */}
            <div className="mt-3 sm:mt-4 md:mt-5 text-center px-2">
              <p className="font-semibold text-gray-800 text-sm sm:text-base md:text-lg lg:text-xl">
                {facilities.find((f) => f.image === selectedImage)?.title}
              </p>
              <p className="text-xs sm:text-sm text-gray-500 mt-1 sm:mt-2">
                Click outside or press ESC to close
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Animation styles */}
      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes scale-up {
          from {
            transform: scale(0.9);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
        .animate-fade-in {
          animation: fade-in 0.2s ease-out;
        }
        .animate-scale-up {
          animation: scale-up 0.3s ease-out;
        }
      `}</style>
    </section>
  );
}